export const VERSION = '1.1';


// WEBPACK FOOTER //
// ./src/version.js